var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"investments"}},[_vm._m(0),_c('div',{staticClass:"investments"},_vm._l((_vm.investments),function(investment){return _c('Empreendimento',{key:investment.title,staticClass:"investment",attrs:{"contents":investment}})}),1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',[_c('span',[_vm._v("Descubra as melhores opções de")]),_vm._v("investimento para você")])
}]

export { render, staticRenderFns }